import { FormEvent, useCallback, useEffect, useState } from 'react';

import { PASSWORD, STORAGE_KEYS } from '@/components/emotion-detector/constants';

export function usePasswordProtection() {
	const [password, setPassword] = useState('');
	const [unlocked, setUnlocked] = useState(false);
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Check if already unlocked from localStorage
		const stored = localStorage.getItem(STORAGE_KEYS.PASSWORD_UNLOCKED);
		if (stored === 'true') {
			// TODO: refactor this code to follow best practices
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setUnlocked(true);
		}
		setIsLoading(false);
	}, []);

	const handlePasswordSubmit = useCallback(
		(e: FormEvent) => {
			e.preventDefault();
			if (password === PASSWORD.CORRECT) {
				setUnlocked(true);
				setError('');
				localStorage.setItem(STORAGE_KEYS.PASSWORD_UNLOCKED, 'true');
			} else {
				setError(PASSWORD.ERROR_INCORRECT);
			}
		},
		[password],
	);

	const logout = useCallback(() => {
		setUnlocked(false);
		localStorage.removeItem(STORAGE_KEYS.PASSWORD_UNLOCKED);
	}, []);

	return {
		password,
		setPassword,
		unlocked,
		error,
		isLoading,
		handlePasswordSubmit,
		logout,
	};
}
